<template>
  <div
    :class="[
        'form-group',
        'form-group--float', {
            'has-error': hasErrors,
            'form-group--active': isNotEmpty,
            'form-group--disabled': disabled,
        }]"
  >
    <label v-show="!hideLabel" :for="name" class="control-label select-label">
      <slot>{{ name }}</slot>
      {{ required ? ' *' : '' }}
    </label>

    <el-select
      v-bind="$attrs"
      :id="name"
      :name="name"
      :value="value"
      :disabled="disabled"
      :placeholder="placeholder"
      :filterable="filterable"
      :required="required"
      autocomplete="new-password"
      @change="onChange"
      class="ui-select form-control"
    >
      <el-option
        v-for="(item, index) in items"
        :key="index"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <span class="form-group__bar"></span>

    <div v-if="hasErrors" class="form-group__errors">
      <p>{{ errors[0] }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormSelect",
  props: {
    name: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: String | Number
    },
    items: {
      required: true,
      type: Array
    },
    errors: {
      required: false,
      type: Array,
      default: () => []
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    filterable: {
      required: false,
      type: Boolean,
      default: true
    },
    placeholder: {
      required: false,
      type: String,
      default: ""
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    hideLabel:{
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    }
  },
  computed: {
    hasErrors() {
      return this.errors.length > 0;
    },
    isNotEmpty() {
      return String(this.value).length > 0;
    }
  }
};
</script>
